import throttle from 'lodash/throttle';
import * as React from 'react';
export function useScrollPeek(params = {}) {
    const [isPeeking, setIsPeeking] = React.useState(true);
    const lastScrollY = React.useRef(0);
    const handleScroll = React.useCallback(throttle(() => {
        if (params.debug) {
            console.log(`Current: ${window.scrollY}, Last: ${lastScrollY.current}`);
        }
        // Check if the user has scrolled.
        if (window.scrollY > (params.threshold ?? 0)) {
            // Check if they scrolled up.
            setIsPeeking(window.scrollY < lastScrollY.current);
            // Update the last scroll value.
            lastScrollY.current = window.scrollY;
        }
        else {
            setIsPeeking(true);
        }
    }, 16.66666666666667), [params.debug, params.threshold]);
    React.useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [params.debug, params.threshold]);
    return isPeeking;
}
